import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

function toDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
}

/** "3 minutes ago", or an em dash when there is genuinely no timestamp. */
export function relativeTime(value: string | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';
  return `${formatDistanceToNowStrict(date)} ago`;
}

export function absoluteTime(value: string | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';
  return format(date, 'd MMM yyyy, HH:mm:ss');
}

export function shortTime(value: string | null | undefined): string {
  const date = toDate(value);
  if (!date) return '—';
  return format(date, 'd MMM, HH:mm');
}

export function isoDate(value: string | null | undefined): string {
  const date = toDate(value);
  if (!date) return '';
  return format(date, 'yyyy-MM-dd');
}

/** Coordinates at roughly metre precision; enough to find a vehicle, not more. */
export function coordinates(lat: number | null, lon: number | null): string {
  if (lat === null || lon === null) return 'Location unavailable';
  return `${lat.toFixed(5)}, ${lon.toFixed(5)}`;
}

export function mapsLink(lat: number, lon: number): string {
  return `https://www.google.com/maps?q=${lat},${lon}`;
}

/** Confidence is a 0–1 score from the rule engine. Never call it an AI score. */
export function confidencePercent(confidence: number): string {
  return `${Math.round(confidence * 100)}%`;
}

export function speedLabel(speed: number | null): string {
  if (speed === null) return '—';
  return `${speed.toFixed(0)} km/h`;
}

/**
 * Resultant acceleration in g. The crash gate is a threshold on exactly this
 * quantity, so it is the one derived figure worth showing next to raw axes.
 */
export function resultantG(x: number, y: number, z: number): number {
  return Math.sqrt(x * x + y * y + z * z) / 9.80665;
}

export function titleCase(value: string): string {
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
